/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCharactersCharacterIdPlanetsPlanetIdFactoryDetails } from './GetCharactersCharacterIdPlanetsPlanetIdFactoryDetails';
import {
    GetCharactersCharacterIdPlanetsPlanetIdFactoryDetailsFromJSON,
    GetCharactersCharacterIdPlanetsPlanetIdFactoryDetailsFromJSONTyped,
    GetCharactersCharacterIdPlanetsPlanetIdFactoryDetailsToJSON,
    GetCharactersCharacterIdPlanetsPlanetIdFactoryDetailsToJSONTyped,
} from './GetCharactersCharacterIdPlanetsPlanetIdFactoryDetails';
import type { GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails } from './GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails';
import {
    GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsFromJSON,
    GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsFromJSONTyped,
    GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsToJSON,
    GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsToJSONTyped,
} from './GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails';
import type { GetCharactersCharacterIdPlanetsPlanetIdContent } from './GetCharactersCharacterIdPlanetsPlanetIdContent';
import {
    GetCharactersCharacterIdPlanetsPlanetIdContentFromJSON,
    GetCharactersCharacterIdPlanetsPlanetIdContentFromJSONTyped,
    GetCharactersCharacterIdPlanetsPlanetIdContentToJSON,
    GetCharactersCharacterIdPlanetsPlanetIdContentToJSONTyped,
} from './GetCharactersCharacterIdPlanetsPlanetIdContent';

/**
 * pin object
 * @export
 * @interface GetCharactersCharacterIdPlanetsPlanetIdPin
 */
export interface GetCharactersCharacterIdPlanetsPlanetIdPin {
    /**
     * contents array
     * @type {Array<GetCharactersCharacterIdPlanetsPlanetIdContent>}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    contents?: Array<GetCharactersCharacterIdPlanetsPlanetIdContent>;
    /**
     * expiry_time string
     * @type {Date}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    expiryTime?: Date;
    /**
     * 
     * @type {GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    extractorDetails?: GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails;
    /**
     * 
     * @type {GetCharactersCharacterIdPlanetsPlanetIdFactoryDetails}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    factoryDetails?: GetCharactersCharacterIdPlanetsPlanetIdFactoryDetails;
    /**
     * install_time string
     * @type {Date}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    installTime?: Date;
    /**
     * last_cycle_start string
     * @type {Date}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    lastCycleStart?: Date;
    /**
     * latitude number
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    latitude: number;
    /**
     * longitude number
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    longitude: number;
    /**
     * pin_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    pinId: number;
    /**
     * schematic_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    schematicId?: number;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdPin
     */
    typeId: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdPlanetsPlanetIdPin interface.
 */
export function instanceOfGetCharactersCharacterIdPlanetsPlanetIdPin(value: object): value is GetCharactersCharacterIdPlanetsPlanetIdPin {
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('pinId' in value) || value['pinId'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdPlanetsPlanetIdPinFromJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdPin {
    return GetCharactersCharacterIdPlanetsPlanetIdPinFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdPinFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdPlanetsPlanetIdPin {
    if (json == null) {
        return json;
    }
    return {
        
        'contents': json['contents'] == null ? undefined : ((json['contents'] as Array<any>).map(GetCharactersCharacterIdPlanetsPlanetIdContentFromJSON)),
        'expiryTime': json['expiry_time'] == null ? undefined : (new Date(json['expiry_time'])),
        'extractorDetails': json['extractor_details'] == null ? undefined : GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsFromJSON(json['extractor_details']),
        'factoryDetails': json['factory_details'] == null ? undefined : GetCharactersCharacterIdPlanetsPlanetIdFactoryDetailsFromJSON(json['factory_details']),
        'installTime': json['install_time'] == null ? undefined : (new Date(json['install_time'])),
        'lastCycleStart': json['last_cycle_start'] == null ? undefined : (new Date(json['last_cycle_start'])),
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'pinId': json['pin_id'],
        'schematicId': json['schematic_id'] == null ? undefined : json['schematic_id'],
        'typeId': json['type_id'],
    };
}

export function GetCharactersCharacterIdPlanetsPlanetIdPinToJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdPin {
    return GetCharactersCharacterIdPlanetsPlanetIdPinToJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdPinToJSONTyped(value?: GetCharactersCharacterIdPlanetsPlanetIdPin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contents': value['contents'] == null ? undefined : ((value['contents'] as Array<any>).map(GetCharactersCharacterIdPlanetsPlanetIdContentToJSON)),
        'expiry_time': value['expiryTime'] == null ? undefined : ((value['expiryTime']).toISOString()),
        'extractor_details': GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsToJSON(value['extractorDetails']),
        'factory_details': GetCharactersCharacterIdPlanetsPlanetIdFactoryDetailsToJSON(value['factoryDetails']),
        'install_time': value['installTime'] == null ? undefined : ((value['installTime']).toISOString()),
        'last_cycle_start': value['lastCycleStart'] == null ? undefined : ((value['lastCycleStart']).toISOString()),
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'pin_id': value['pinId'],
        'schematic_id': value['schematicId'],
        'type_id': value['typeId'],
    };
}

